import { render, staticRenderFns } from "./CmgFavoriteRestaurantModal.vue?vue&type=template&id=63eca159&scoped=true&lang=pug&"
import script from "./cmg-favorite-restaurant-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-favorite-restaurant-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFavoriteRestaurantModal.vue?vue&type=style&index=0&id=63eca159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eca159",
  null
  
)

export default component.exports